module.exports = __webpack_public_path__ + "static/xinchou-6dc515b170a2f753d911f7964add1f9c.png";